<template>
  <div>
    <el-dialog title="Shipment Product List" :visible.sync="dialogVisible" width="1000px" @open="open">
      <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%">
        <el-table-column prop="invoiceNumber" label="ERP Shipment Number" align="left" />
        <el-table-column prop="erpOrderNumber" label="Order Number" align="left" />
        <el-table-column prop="porductCode" label="Material Code" align="left" />
        <el-table-column prop="productName" label="Product Name" align="left" />
        <el-table-column prop="number" label="Quantity" align="left" />
        <el-table-column prop="productUnit" label="Unit" align="left" />
        <!-- todo 该字段需要等后端给 -->
        <el-table-column prop="actualProduct" label="Actual Product" align="left" />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { getDeliveryDetails } from '@/API';

export default {
  name: 'InternationalShippingListDialog',
  props: {
    dialogVisibleFromShippingList: {
      type: Boolean,
      default: false
    },
    currentClickData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogVisible: this.dialogVisibleFromShippingList,
      tableData: [],
      tableLoading: false
    };
  },
  watch: {
    dialogVisibleFromShippingList (value) {
      this.dialogVisible = value;
    },
    dialogVisible (value) {
      this.$emit('on-status-dialog', value);
    }
  },
  methods: {
    initData () {
      this.tableLoading = true;
      getDeliveryDetails(this.currentClickData.contractNum, this.currentClickData.invoiceNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.productList;
          this.tableData.forEach((item) => {
            this.$set(item, 'erpOrderNumber', json.data.erpOrderNumber);
          });
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 打开页面调用接口
    open () {
      this.initData();
    }
  }
};
</script>

<style></style>
